import React, { Component } from 'react'
import { connect } from 'react-redux'
import BkFlowSidebarRoomCardDefault from './layouts/BkFlowSidebarRoomCardDefault'
import BkFlowSidebarRoomCardCondensed from './layouts/BkFlowSidebarRoomCardCondensed'

import formatPrice from '../../../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'

import _ from 'lodash'
import moment from 'moment'
import yn from 'yn'

class BkFlowSidebarRoomCard extends Component {
	constructor(props) {
		super(props)
		this.state = {
			detailsExpanded: true
		}

		this.handleDetailsAccordion = this.handleDetailsAccordion.bind(this)
	}

	handleDetailsAccordion() {
		this.setState({
			detailsExpanded: !this.state.detailsExpanded
		})
	}

	render() {
		const {
			configData,
			urlData,
			roomKey,
			activeRoom,
			activeEnhancementData,
			activeCurrencyData,
			roomRateDetailsData
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		// Window.session data for guests / pets
		let flowGuestData = null

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		const arrival = moment(urlData.startDate).format('dddd, MMMM D, YYYY')
		const departure = moment(urlData.endDate).format('dddd, MMMM D, YYYY')
		const nights = moment(urlData.endDate).diff(urlData.startDate, 'days')
		const totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

		let activeHotelCode = null
		let roomName = null
		let roomCode = null
		let roomRatePlan = null
		let roomRateCode = null
		let adults = urlData.adults
		let children = urlData.children
		let isTaxInclusiveProperty = false
		let renderChildren = ''
		let renderAdult = ''
		let enhancementsData = []
		let matchedProperty = null
		let roomPrice = null
		let currencyCode = 'USD'
		let currencySymbol = getCurrencySymbol(currencyCode)
		let roomRateDestinationFeeCode = null
		let roomRateTaxes = []
		let propertyClassType = 20
		let displayedPriceFrequency = 'per stay'

		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.displayPricesTaxInclusive
			) {
				isTaxInclusiveProperty = matchedProperty.displayPricesTaxInclusive
			}

			if (
				matchedProperty &&
				matchedProperty.propertyClassType
			) {
				propertyClassType = Number(matchedProperty.propertyClassType)
			}

			if (
				matchedProperty &&
				matchedProperty.displayPricesTimeline
			) {
				displayedPriceFrequency = matchedProperty.displayPricesTimeline
			}
		}

		if (activeRoom[roomKey]) {
			if (_.get(activeRoom[roomKey], '[0][0].roomDescription.name')) {
				roomName = activeRoom[roomKey][0][0].roomDescription.name
			}

			if (_.get(activeRoom[roomKey], '[0][0].roomTypeCode')) {
				roomCode = activeRoom[roomKey][0][0].roomTypeCode
			}

			if (_.get(activeRoom[roomKey], '[2][0].ratePlanName')) {
				roomRatePlan = activeRoom[roomKey][2][0].ratePlanName
			}

			if (_.get(activeRoom[roomKey], '[2][0].ratePlanCode')) {
				roomRateCode = activeRoom[roomKey][2][0].ratePlanCode
			}

			if (_.get(activeRoom[roomKey], '[1][0].rates[0].total.currencyCode')) {
				currencyCode = activeRoom[roomKey][1][0].rates[0].total.currencyCode
				currencySymbol = getCurrencySymbol(currencyCode)
			}

			if (_.get(activeRoom[roomKey], '[1][0].viewExtensions.resortDestinationFeeCode')) {
				roomRateDestinationFeeCode = activeRoom[roomKey][1][0].viewExtensions.resortDestinationFeeCode
			}

			if (_.get(activeRoom[roomKey], '[1][0].rates[0].total.taxes.tax')) {
				roomRateTaxes = activeRoom[roomKey][1][0].rates[0].total.taxes.tax
			}
		}

		let destinationFeeAmount = null

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_DESTINATION_FEES) &&
			!_.isEmpty(roomRateTaxes) &&
			roomRateDestinationFeeCode
		) {
			let roomRateDestinationFee = roomRateTaxes.filter(tax => {
				return Number(tax.code) === Number(roomRateDestinationFeeCode)
			})

			if (_.get(roomRateDestinationFee, '[0].amount')) {
				destinationFeeAmount = roomRateDestinationFee[0].amount

				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX)&&
					activeCurrencyData.exchangeRate
				) {
					destinationFeeAmount = roomRateDestinationFee[0].amount * activeCurrencyData.exchangeRate
				}
			}
		}

		// set adults by flowGuestData
		if (flowGuestData && flowGuestData[roomKey]) {
			if (flowGuestData[roomKey].adults > 0) {
				adults = flowGuestData[roomKey].adults
			}

			// set children by flowGuestData
			if (flowGuestData[roomKey].children > 0) {
				children = flowGuestData[roomKey].children
			}
		}

		// Construct adults
		if (adults === 1) {
			renderAdult = adults + ' ' + hotelLabels.adult
		} else {
			renderAdult = adults + ' ' + hotelLabels.adults
		}

		// Construct children
		if (children === 1) {
			renderChildren = children + ' ' + hotelLabels.child
		} else {
			renderChildren = children + ' ' + hotelLabels.children
		}

		// Build enhancement totals
		if (!_.isEmpty(activeEnhancementData)) {

			// Loop for related enhancements by roomGroup and roomType
			for (let enhancementKeys in activeEnhancementData) {

				if (
					Number(activeEnhancementData[enhancementKeys].roomGroup) === Number(roomKey) &&
					activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode
				) {
					const currentEnhancement = activeEnhancementData[enhancementKeys]
					let keyedDetails = {}

					// Loop and uniquely key enhancement details
					if (!_.isEmpty(currentEnhancement.enhancementApiData.serviceDetails.comments)) {
						const currentDetails = currentEnhancement.enhancementApiData.serviceDetails.comments

						for (let detailKey in currentDetails) {
							keyedDetails[currentDetails[detailKey].name.toLowerCase()] = currentDetails[detailKey]
						}
					}
					if (
						keyedDetails.title &&
						keyedDetails.title.text
					) {
						enhancementsData.push(
							<p
								className="bk-flow-payment__sidebar-room-card-detail u-font-medium"
								key={ keyedDetails.title.text + '-' + roomKey }
							>
								<span>{ keyedDetails.title.text }{ _.get(currentEnhancement.enhancementApiData, '.price[0].base.amountBeforeTax') && ': ' }</span>
								{ _.get(currentEnhancement.enhancementApiData, '.price[0].base.amountBeforeTax') &&
								<span>
									{currencySymbol}
									{currentEnhancement.enhancementApiData.price[0].base.amountBeforeTax}
									{currencyCode}/{activeEnhancementData[enhancementKeys].enhancementApiData.servicePricingType}
								</span>
								}
							</p>
						)
					}
				}
			}
		}

		if (displayedPriceFrequency === 'per stay') {
			if (isTaxInclusiveProperty) {
				roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax, 2)
			} else {
				roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax, 2)
			}
		} else {
			if (isTaxInclusiveProperty) {
				roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax / totalNights, 2)
			} else {
				roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax / totalNights, 2)
			}
		}

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			currencyCode = activeCurrencyData.currencyCode
			currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)

			if (displayedPriceFrequency === 'per stay') {
				if (isTaxInclusiveProperty) {
					roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2)
				} else {
					roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate, 2)
				}
			} else {
				if (isTaxInclusiveProperty) {
					roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax / totalNights * activeCurrencyData.exchangeRate, 2)
				} else {
					roomPrice = formatPrice(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate, 2)
				}
			}
		}


		let nightlyRateData = null

		if (
			_.get(activeRoom, '[0][1][0].viewExtensions.nightlyRates') &&
			!_.isEmpty(activeRoom[0][1][0].viewExtensions.nightlyRates)
		) {
			nightlyRateData = activeRoom[0][1][0]
		} else if (
			roomCode &&
			roomRateCode &&
			roomRateDetailsData &&
			roomRateDetailsData[roomCode + '-' + roomRateCode + '-' + roomKey]
		) {
			const currentRoomRateDetails = roomRateDetailsData[roomCode + '-' + roomRateCode + '-' + roomKey]

			if (
				currentRoomRateDetails &&
				currentRoomRateDetails.viewExtensions &&
				currentRoomRateDetails.viewExtensions.nightlyRates &&
				!_.isEmpty(currentRoomRateDetails.viewExtensions.nightlyRates)
			) {
				nightlyRateData = currentRoomRateDetails
			}
		}

		return (
			process.env.REACT_APP_COMPONENT_PAYMENT_ROOM_CARD_LAYOUT === 'condensed' ? (
				<BkFlowSidebarRoomCardCondensed
					activeCurrencyData={activeCurrencyData}
					adults={adults}
					arrival={arrival}
					children={children}
					configData={configData}
					currencyCode={currencyCode}
					currencySymbol={currencySymbol}
					departure={departure}
					detailsExpanded={this.state.detailsExpanded}
					displayedPriceFrequency={displayedPriceFrequency}
					enhancementsData={enhancementsData}
					handleDetailsAccordion={this.handleDetailsAccordion}
					hotelLabels={hotelLabels}
					nights={nights}
					nightlyRateData={nightlyRateData}
					renderAdult={renderAdult}
					renderChildren={renderChildren}
					roomName={roomName}
					roomPrice={roomPrice}
					roomRatePlan={roomRatePlan}
				/>
			) : (
				<BkFlowSidebarRoomCardDefault
					activeCurrencyData={activeCurrencyData}
					adults={adults}
					arrival={arrival}
					children={children}
					configData={configData}
					currencyCode={currencyCode}
					currencySymbol={currencySymbol}
					departure={departure}
					destinationFeeAmount={destinationFeeAmount}
					detailsExpanded={this.state.detailsExpanded}
					displayedPriceFrequency={displayedPriceFrequency}
					enhancementsData={enhancementsData}
					handleDetailsAccordion={this.handleDetailsAccordion}
					hotelLabels={hotelLabels}
					nights={nights}
					nightlyRateData={nightlyRateData}
					propertyClassType={propertyClassType}
					renderAdult={renderAdult}
					renderChildren={renderChildren}
					roomName={roomName}
					roomPrice={roomPrice}
					roomRateCode={roomRateCode}
					roomRatePlan={roomRatePlan}
				/>
			)
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
		multiRoomData: state.multiRoomData,
		availabilityLoading: state.availabilityData.loading,
		activeRoom: state.activeRoomData,
		activeEnhancementData: state.activeEnhancementData,
		activeCurrencyData: state.activeCurrencyData,
		roomRateDetailsData: state.roomRateDetailsData.roomRateDetails,
	}
}

export default connect(mapStateToProps, null)(BkFlowSidebarRoomCard)


// WEBPACK FOOTER //
// ./src/components/payment/sidebar/room/BkFlowSidebarRoomCard.js